import * as types from "./mutationTypes";

export default {
  [types.CLEAR_EXTRACT](state) {
    state.extract = [];
    state.totalExtract = 0;
    state.resume = {};
    state.queryParams = {};
  },
  [types.SET_EXTRACT](state, { extract }) {
    state.extract = extract;
  },
  [types.SET_RESUME](state, resume) {
    state.resume = resume;
  },
  [types.SET_QUERY_PARAMS](state, queryParams) {
    state.queryParams = queryParams;
  }
};
